import { useState, useEffect } from 'react'
import { LoadingView } from '../../components/LoadingView'
import { ButtonGroup, SIZE, SHAPE, } from 'baseui/button-group';
import { Button } from 'baseui/button';
import { Block } from 'baseui/block';
import {  DashboardView, DeleteDashboardButton } from '.'
import { useStyletron } from 'baseui'
import { VscEdit } from 'react-icons/vsc'
import { useHasRole } from '../../hooks/useHasRole'
import { AccessRoles } from '../../hooks/useHasRole/accessRoles'
import { IDashboardCollection } from './types'
import { useGetDashboards } from '../../hooks/useGetDashboards'


const DashboardsView = (props: { refetch: any }) => {
    const [css, theme] = useStyletron();
    const { objects: data, error, isLoading, isSuccess, refetch } = useGetDashboards();
    const [selected, setSelected] = useState<IDashboardCollection>();
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [edit, setEdit] = useState(false);
    const hasAccess = useHasRole(AccessRoles.Dashboard.Write);

    useEffect(() => {
        if (data && data.length > 0) {
            const item = data[0];
            setSelected(item);
            setSelectedIndex(data?.indexOf(item) + 1 || -1);
        }
    }, [data]);

    useEffect(() => { setTimeout(()=>{refetch();}, 5000); }, [props.refetch]);

    const handleOnDeletedDashboard = () => setTimeout(()=>{refetch();}, 5000);
    const handleSelectDashboardClick = (item: IDashboardCollection) => {
        setSelected(item);
        if (data)
            setSelectedIndex(data.indexOf(item) + 1);
        else
            setSelectedIndex(-1);
    }

    return (
        <>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <Block flexDirection='row' display='flex' justifyContent='space-between' gridColumnGap={theme.sizing.scale100}>
                    <Block flexDirection='row' display='flex' justifyContent='flex-start' overflow='auto' gridColumnGap={theme.sizing.scale100}>
                        {data?.map((item: IDashboardCollection, index: number) => (
                            <Button overrides={
                                {
                                    BaseButton:
                                    {
                                        style:
                                            { whiteSpace: "nowrap" }
                                    }
                                }
                            } size={SIZE.mini}
                                shape={SHAPE.pill}
                                kind='secondary'
                                isSelected={selectedIndex === index + 1} key={item.id} onClick={() => handleSelectDashboardClick(item)}>{item.name}</Button>
                        ))}
                    </Block>
                    <ButtonGroup shape='circle' kind='tertiary' size='compact'>
                        {edit && selected &&
                            <DeleteDashboardButton onDeleted={handleOnDeletedDashboard} resourceGroupId={selected.resourceGroupId} dashboardId={selected.id} dashboardName={selected.name}></DeleteDashboardButton>
                        }
                        <Button disabled={!hasAccess} isSelected={edit} kind='tertiary' shape='circle' onClick={() => setEdit(!edit)}><VscEdit></VscEdit></Button>
                    </ButtonGroup>
                </Block>
            </LoadingView >
            <Block marginTop={theme.sizing.scale500} >
                {selected && <DashboardView edit={edit} dashboard={selected}></DashboardView>}
            </Block>
        </>
    )
}

export default DashboardsView;





